import { BFFAgent } from 'BFFAgent'
import { put, call } from 'redux-saga/effects'
import * as commonActions from 'common/redux/actions'
import {
  STOCK_TAKING_CAR_MANAGEMENT_DETAILS_BEGIN,
  STOCK_TAKING_CAR_MANAGEMENT_REPEAT_REQUEST_SUCCESS,
  STOCK_TAKING_CAR_MANAGEMENT_REPEAT_REQUEST_FAILURE
} from '../constants'

export function* repeatTakingCarRequestSaga({ data: { requestsId, takingCarId } }) {
  try {
    const result = yield call(
        BFFAgent.Stock.TakingCarManagement.repeatTakingCarRequest,
        requestsId
    )

    if (result) {
      yield put({
        type: STOCK_TAKING_CAR_MANAGEMENT_REPEAT_REQUEST_SUCCESS,
        data: result
      })
      yield put({
        type: STOCK_TAKING_CAR_MANAGEMENT_DETAILS_BEGIN,
        data: {takingCarId}
      })
      commonActions.SuccessAction({
        title: '¡Listo! Se envió una solicitud de reperitaje con éxito. Una vez finalizado el reperitaje, podrás continuar gestionando este auto.',
      })
    }
  } catch (error) {
    yield put({
      type: STOCK_TAKING_CAR_MANAGEMENT_REPEAT_REQUEST_FAILURE,
      data: { error }
    })
    commonActions.ErrorAction({
        title: 'No fue posible generar la solicitud de reperitaje.'
    })
  }

}
